import React, { useState, useEffect } from 'react';
import { DropdownListView } from './DropdownListView';
import { Button } from 'wbm-inputs';
import { OutlinedIcon, SelectIcon } from '../../index';
import { AddToCartFavorite } from './AddFavorite';
import { AddNote, AddNoteModal, SelectedToolTip } from '../../index';
import { ListInt } from '../dropdown/List';
import { InlineAlertSuccess } from '../../components/inlineAlertSuccess/inlineAlertSuccess';
import DeleteIcon from '@material-ui/icons/Delete';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import CheckIcon from '@material-ui/icons/Check';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import { ICartItem } from '../../interfaces/cartItem';
import { ItemIdentifier } from '../../interfaces/itemIdentifier';
import { ISupercedeProduct } from "wbm-cart-service/interfaces/supercedeProduct";
import { Observable } from 'rxjs';
import { SuccessAlert } from "../SuccessAlert";

export interface AddToCartProps {
    added?: boolean,
    addedNoteIcon: Function,
    addNote?: boolean,
    charRemain?: number,
    list: Array<ListInt>,
    favSelected: boolean,
    setFavorite: any,
    AddItemSelected: any,
    inputVal?: string,
    itemSelected: any,
    removeFavorite?: any,
    manageList?: boolean,
    saveNote: Function,
    setLength?: number,
    tooltipText?: string,
    buttonClass?: string,
    buttonContent?: JSX.Element,
    addedToCart?: ICartItem[],
    supercedeItems?: ISupercedeProduct[],
    itemIdentifier?: ItemIdentifier,
    changeZIndex?: Function,
    quantityMessage?: string,
    errorMessage?: JSX.Element,
    error?: string,
    doPreventAddToCart?: boolean,
    slideInfo?: string,
    isSkuGroupSearch?: boolean,
    forceInput?: boolean;
    qtyOnBlur?: (qty: any) => Observable<any>;
    isAddToCartActive?: boolean;
    inputIdentifier: string;
    inputLabel: string;
    noteComponent?: JSX.Element,
}

export const AddToCartActionView = ({ ...props }: AddToCartProps) => {
    const [dropVals, storeDropVals] = useState({ val: props.list[0].value, text: props.list[0].text });
    const [loading, setLoading] = useState(false);
    const [displayToastError, setDisplayToastError] = useState<boolean>(false);
    const [addToCartClicked, setAddToCartClicked] = useState(false);
    const [deleteSelected, setDeleteSelected] = useState(false);

    const [tooltipTimeoutId, setTooltipTimeoutId] = useState<number | NodeJS.Timeout>(0);

    const qtyMsgClass = { marginRight: '5px', height: '20px', width: '20px', alignSelf: "flex-start" }
    let qtyElement =
        <>
            <CheckIcon style={qtyMsgClass} />
            <span>Added</span>
        </>;

    if (props.quantityMessage) {
        const qtyMsg1 = props.quantityMessage.split('.')[0];
        const qtyMsg2 = props.quantityMessage.split('.')[1];
        qtyElement =
            <>
                <ErrorIcon style={qtyMsgClass} />
                <span>{qtyMsg1}.<b>{qtyMsg2}.</b></span>
            </>
    }

    const setValsToSave = (selectedValue: any, selectedText: any) => {
        storeDropVals({ val: selectedValue, text: selectedText });
        props.itemSelected && props.itemSelected(selectedValue, selectedText);
    }

    const sendStoreValues = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        if (props.AddItemSelected) {
            setLoading(true);
            setAddToCartClicked(true);
            props.AddItemSelected(dropVals.val, dropVals.text);
        }
    }

    useEffect(() => {
        if (addToCartClicked && props.addedToCart !== undefined && props.addedToCart.length > 0 && props.itemIdentifier && !props.isAddToCartActive) {
            if (props.addedToCart?.some(
                (x) => {
                    return x.itemIdentifier.id === props.itemIdentifier?.id && x.itemIdentifier.unitId === props.itemIdentifier?.unitId;
                }
            )) {
                setAddToCartClicked(false);
                setLoading(false);
                if (props.slideInfo) {
                    setTooltipTimeoutId(0);
                } else {
                    if (tooltipTimeoutId > 0) {
                        clearTimeout(tooltipTimeoutId);
                    }
                    const timeoutId = setTimeout(() => { setTooltipTimeoutId(0); }, 3500);
                    setTooltipTimeoutId(timeoutId);
                }
            } else {
                setLoading(false);
            }
        }
    }, [props.addedToCart, props.isAddToCartActive]);

    useEffect(() => {
        if (props.error && props.error !== "") {
            setDisplayToastError(true);
            setLoading(false);
        }
    }, [props.error])

    useEffect(() => {
        if (props.doPreventAddToCart || !props.isAddToCartActive) {
            setLoading(false);
        }
    }, [props.doPreventAddToCart, props.isAddToCartActive]);

    function removeFavorites() {
        setDeleteSelected(true);
        props.removeFavorite();
    }

    return (
        <React.Fragment>
            <DropdownListView list={props.list} itemSelected={setValsToSave} setLength={props.setLength} changeZIndex={props.changeZIndex} isSkuGroupSearch={props.isSkuGroupSearch} qtyOnBlur={props.qtyOnBlur} forceInput={props.forceInput} inputIdentifier={props.inputIdentifier} inputLabel={props.inputLabel} />
            {props.added ?
                <React.Fragment><InlineAlertSuccess message="ADDED" /><div className="col" /></React.Fragment>
                :
                <SelectedToolTip arrow placement="top" open={tooltipTimeoutId > 0}
                    title={qtyElement}>
                    <Button className={`${props.buttonClass}${props.favSelected ? " my-list" : ""}`} onClick={(event: React.MouseEvent<HTMLButtonElement>) => sendStoreValues(event)} disabled={loading}>
                        {loading ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" /> : props.buttonContent}
                    </Button>
                </SelectedToolTip>
            }

            {displayToastError &&
                <SuccessAlert
                    timerLengthInMS={3500}
                    danger
                    dangerText="Please try again. If the problem persists, please call 1-888-WB-MASON."
                    dangerAttentionText="An error has occurred!"
                    onClickClose={() => setDisplayToastError(false)}
                    attentionText={''}
                    text={''}
                />}

            {props.addNote && props.noteComponent &&
                <div className="add-note">{props.noteComponent}</div>
            }
            {props.setFavorite && props.manageList &&
                <span className="delete-icon">
                    <SelectIcon selected={deleteSelected} onClick={() => removeFavorites()} selectText="Remove from List" icon={!deleteSelected ? <DeleteOutlinedIcon /> : <DeleteIcon />} color="red" />
                </span>
            }
            {props.setFavorite && <AddToCartFavorite favSelected={props.favSelected} setFavorite={() => props.setFavorite()} />}
        </React.Fragment>
    );
}

AddToCartActionView.defaultProps = {
    buttonClass: "col btn-primary",
    buttonContent: "Add To Cart"
};